import script from "./WorkView.vue?vue&type=script&setup=true&lang=ts"
export * from "./WorkView.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__